module.exports = __webpack_public_path__ + "media/images/top/topics-bottom-75e085d210ecb5441b7cc2dc41836f3c.svg";